<template>
  <div id="app">
    <LoadingScreen :is-loaded="isLoaded" />
    <div class="page-content" :class="{ 'content-loaded': isLoaded }">
      <SiteHeader />
      <router-view />
      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'
import LoadingScreen from './components/LoadingScreen.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter,
    LoadingScreen
  },
  data() {
    return {
      isLoaded: false
    }
  },
  mounted() {
    // 模拟页面加载延迟
    setTimeout(() => {
      this.isLoaded = true
    }, 2000)
  }
}
</script>

<style>
:root {
  --primary-color: #4a86e8;
  --primary-dark: #3367d6;
  --primary-light: #7dabf5;
  --text-dark: #2c3e50;
  --text-light: #ffffff;
  --bg-light: #f8fafc;
  --bg-gradient: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  --border-radius: 12px;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: var(--text-dark);
  background: var(--bg-gradient);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
  position: relative;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #64748b;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 3rem;
}

.card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.3px;
  text-decoration: none;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn:hover::before {
  opacity: 1;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  color: white;
  box-shadow: 
    0 4px 15px rgba(74, 134, 232, 0.3),
    0 1px 2px rgba(0, 0, 0, 0.1),
    0 1px 0 rgba(255, 255, 255, 0.2) inset;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 8px 25px rgba(74, 134, 232, 0.4),
    0 2px 3px rgba(0, 0, 0, 0.1),
    0 1px 0 rgba(255, 255, 255, 0.3) inset;
}

.btn-primary:active {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(74, 134, 232, 0.3);
}

.btn-outline {
  background: rgba(255, 255, 255, 0.8);
  border: 1.5px solid var(--primary-color);
  color: var(--primary-color);
  box-shadow: 0 2px 10px rgba(74, 134, 232, 0.1);
  backdrop-filter: blur(5px);
}

.btn-outline:hover {
  background: rgba(74, 134, 232, 0.1);
  color: var(--primary-dark);
  border-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(74, 134, 232, 0.2);
}

.btn-outline:active {
  transform: translateY(1px);
  box-shadow: 0 1px 5px rgba(74, 134, 232, 0.15);
}

/* 添加玻璃态效果 */
.glass-effect {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

/* 添加渐变背景 */
.gradient-bg {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1rem;
  }
}

.page-content {
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.content-loaded {
  opacity: 1;
}
</style>
